<template>
    <div class="cartao-cnpj">
        <div class="div_razao_social">
            Cliente:
            <strong style="font-size: 16px" role="button" class="razao_social"
                v-if="(show_only.length == 0 || show_only.includes('name'))" v-b-tooltip.hover
                @click="$bvModal.show('cliente')" title="Clique para editar o cadastro do cliente.">
                <span v-if="cliente && cliente.nome_loja">
                    {{ cliente.nome_loja }}</span>
                <span v-else-if="cliente && cliente.razao_social">{{
                    cliente.razao_social
                }}</span>
            </strong>
            <br />
            <small>CPF/CNPJ:</small><span> {{ cliente.cliente_documento_mask }} </span>
            <br />
            <div v-if="(show_only.length == 0 || show_only.includes('parceiro'))">
                <small v-if="parceiro.is_ar && cliente.parceiro">Parceiro:</small>
                <span v-if="parceiro.is_ar" role="button" @click.prevent="$router.push({
                    name: 'indicacoes', params: { parceiro_id: cliente.parceiro.user_id }
                })">
                    <span v-if="cliente.parceiro && cliente.parceiro.user_razao_social">{{
                        cliente.parceiro.user_razao_social
                    }}</span>
                    <span v-else-if="cliente.parceiro && cliente.parceiro.name">{{
                        cliente.parceiro.name
                    }}</span>
                </span>
            </div>
        </div>

        <!--                        Razão Social: <b><span class="razao_social"></span></b>-->

        <div v-if="(show_only.length == 0 || show_only.includes('address'))">
            <small>Endereço:</small>
            <span class="callradouro">{{ cliente.logradouro }}</span>
            <small>Nº:</small>
            <span class="numero">{{ cliente.numero }}</span>
            <small>Complemento:</small>
            <span class="complemento">{{ cliente.complemento }}</span>
            <small>Bairro:</small>
            <span class="bairro">{{ cliente.bairro }}</span>
            <small>Cidade:</small>
            <span class="cidade">{{ cliente.municipio }}</span>
            <small>UF:</small>
            <span class="uf">{{ cliente.uf }}</span>
            <small>CEP:</small>
            <span class="cep">{{ cliente.cep }}</span>
        </div>
        <small>Telefone:</small>
        <span class="telefone">{{ cliente.telefone_1 }}
            <span v-if="cliente.telefone_1 && cliente.telefone_2">/</span>
            {{ cliente.telefone_2 }}</span>

        <small>Email:</small>
        <span class="email">{{ cliente.email }}
        </span>
        <br />
        <!--                    Sócio administrador: <b><span class="socio-administrador"></span></b>-->
        <modal id="cliente" title="Alterar cadastro do cliente" size="md" form="clienteForm" btn_save>
            <cliente-form :cliente_id="Number(cliente_id)" @updated="getCliente()" />
        </modal>
    </div>
</template>
<script>
import { mapState } from "vuex";
import clienteForm from "../clientes/forms/clienteForm.vue";
export default {
    components: { clienteForm },
    data() {
        return {
            cliente: {},
        };
    },
    computed: {
        ...mapState("user", ["parceiro"]),
    },
    props: {
        cliente_id: "",
        show_only: { type: Array, default: [] }
    },
    watch: {
        cliente_id() {
            if (this.cliente_id) this.getCliente();
        },
    },
    created() {
        this.getCliente();
    },
    methods: {
        async getCliente() {
            const result = await this.$api.get(`cliente/${this.cliente_id}`);

            this.cliente = result.data;

            this.$emit("setCliente", result.data);
        },
    },
};
</script>
